export class Account {
  reference: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  company_name: string;
  logo: string;
  token: string;
  /** Unix timestamp (seconds) when the token expires. */
  expires: number;
}

/** True if token has expired (or no expiry). Uses 60s buffer so we don't send a token about to expire. */
export function isTokenExpired(expires: number | undefined): boolean {
  const nowSec = Math.floor(Date.now() / 1000);
  return expires <= nowSec + 60;
}
